import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React, { useCallback, useContext, useMemo, useState } from 'react'
import { Link } from 'react-router-dom';
import { Context } from '..';
import axios from 'axios';

export const TableRow = (props) => {
  const { bookName, bookPhone, bookEmail, createdAt, status, ticket, id, total, paidAt, endPointId, paymentMethod, images, images2 } = props;

  const { state, dispatch } = useContext(Context);

  const linkTo = `/ship/ticket/waiting?cartId=${id}`

  const datedString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const paidString = moment(paidAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  const handleConfirmPayment = useCallback(() => {
    dispatch({
      type: 'OPEN_CONFIRM_POPUP',
      payload: {
        content: 'Bạn muốn xác nhận đơn hàng này đã được thanh toán?',
        cartId: id,
      }
    })
  }, [])

  const handleConfirmSendPayment = useCallback(() => {
    dispatch({
      type: 'OPEN_ZNS_POPUP',
      payload: {
        content: 'Bạn muốn gửi mã đơn đến khách hàng?',
        cartId: id,
      }
    })
  }, [])

  const handleExport = useCallback(() => {
    dispatch({
      type: 'OPEN_EXPORT_POPUP',
      payload: {
        id: id,
      }
    })
  }, [])

  const handleView = useCallback(() => {
    window.open(images, '_blank', 'noopener,noreferrer');
  }, [])

  const handleView2 = useCallback(() => {
    window.open(images2, '_blank', 'noopener,noreferrer');
  }, [])

  const actionTd = useMemo(() => {
    if (status === 0) {
      return (<Button variant='danger' onClick={handleConfirmPayment}>
        Xác nhận thanh toán
      </Button>);
    } else if (status === 1) {
      return (
        <>
          <Button variant='info'>
            <Link
              target={'_blank'}
              style={{ color: '#fff' }}
              to={linkTo}
              key={id}
            >
              {'Xem vé'}
              <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
            </Link>
          </Button>
          &nbsp;
          <Button variant='warning' onClick={handleExport}>
            Xuất vé
          </Button>
        </>)
    }
    return (
      <>
        <Button variant='info' onClick={handleView}>
          Xem vé 1
        </Button>
        &nbsp;
        <Button variant='info' onClick={handleView2}>
          Xem vé 2
        </Button>
        &nbsp;
        <Button variant='info'>
          <Link
            target={'_blank'}
            style={{ color: '#fff' }}
            to={linkTo}
            key={id}
          >
            {'Chi tiết'}
            <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
          </Link>
        </Button>
        &nbsp;
        <Button variant='success' onClick={handleConfirmSendPayment}>
          {'Gửi vé'}
        </Button>
      </>
    )
  }, [id, linkTo, status])

  const statusTd = useMemo(() => {
    if (status === 0) {
      return <strong className={`text-danger`}>Chưa thanh toán</strong>;
    } else if (status === 1) {
      return <strong className={`text-warning`}>Đã thanh toán</strong>;
    }
    return <strong className={`text-success`}>Đã xuất vé</strong>;
  }, [id, linkTo, status])

  return (
    <tr>
      <td className="text-center">
        {actionTd}
      </td>
      <td className="text-center">{id}</td>
      <td>
        Tên: <strong className={`text-primary`}>{bookName}</strong><br />
        SĐT: <strong className={`text-primary`}>{bookPhone}</strong><br />
        Email: <strong className={`text-primary`}>{bookEmail}</strong>
      </td>
      <td className="text-center">{ticket}</td>
      <td className="text-center">{new Intl.NumberFormat('vn-VI', {}).format(total) || ""}</td>
      <td className="text-center">{datedString}</td>
      <td className="text-center">{paidAt ? paymentMethod : ''}</td>
      <td className={`text-center${status == 0 ? ' text-danger' : ' text-success'}`}>{paidAt ? paidString : 'Chưa thanh toán'}</td>
      <td className="text-center">{statusTd}</td>
    </tr>
  );
};